import { render, staticRenderFns } from "./EchartPie.vue?vue&type=template&id=6bd5d594&scoped=true&"
import script from "./EchartPie.vue?vue&type=script&lang=js&"
export * from "./EchartPie.vue?vue&type=script&lang=js&"
import style0 from "./EchartPie.vue?vue&type=style&index=0&id=6bd5d594&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd5d594",
  null
  
)

export default component.exports